import React from 'react';
import { Row } from 'react-table';

import { formatNumberCompact } from '@trqk/utils';

import { footerHeight, COLUMN_IDS } from '../../constants';

interface IncludedAudioFilesFooterProps {
    rows: Row<TrqkGapChannel>[];
}

/**
 * Summarizes and displays the total of all `cell.value.stats`s for the `IncludedAudioFileCell`s.
 * @param props - {@link EstimatedLossFooterProps}
 */
export function IncludedAudioFilesFooter({
    rows,
}: IncludedAudioFilesFooterProps): JSX.Element {
    const summaryStats = rows.reduce(
        (
            acc: GapChannelAudioFileStats,
            row: Row<TrqkGapChannel>,
        ): GapChannelAudioFileStats => {
            const checked =
                row?.values?.[COLUMN_IDS.INCLUDE_CHANNEL]?.checked ?? false;

            if (checked) {
                acc.included +=
                    row?.values?.[COLUMN_IDS.INCLUDED_AUDIO_FILES]?.stats
                        ?.included ?? 0;
            }

            acc.total +=
                row?.values?.[COLUMN_IDS.INCLUDED_AUDIO_FILES]?.stats?.total ??
                0;

            return acc;
        },
        { included: 0, total: 0 },
    );

    const includedCount = formatNumberCompact(summaryStats.included);
    const total = formatNumberCompact(summaryStats.total);

    return (
        <div
            className="flex items-center pl-1"
            style={{ height: footerHeight }}
        >
            <p>
                {includedCount} of {total}
            </p>
        </div>
    );
}
